export enum EPlatform {
  Connect = 'connect',
}
